import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions, GridReadyEvent, ColumnApi } from 'ag-grid-community';
import { AvailabilityDisplayFrame } from './AvailabilityReport.types';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import './AvailabilityReport.pcss';

export interface AvailabilityReportTableProps {
  gridOptions: GridOptions;
  rowData: AvailabilityDisplayFrame[];
  columnDefs: ColDef[];
  pinnedBottomRowData?: AvailabilityDisplayFrame[];
  getColumnApi?: (api: ColumnApi) => void;
  onGridReady?: (event: GridReadyEvent) => void;
}

export const AvailabilityReportTable: React.FC<AvailabilityReportTableProps> = ({
  gridOptions,
  rowData,
  columnDefs,
  pinnedBottomRowData,
  getColumnApi,
  onGridReady,
}) => {
  const handleGridReady = (event: GridReadyEvent): void => {
    getColumnApi?.(event.columnApi);
    onGridReady?.(event);
  };

  return (
    <div className="ag-theme-material availability-report-table h-[94%]">
      <AgGridReact
        gridOptions={gridOptions}
        onGridReady={handleGridReady}
        rowData={rowData}
        columnDefs={columnDefs}
        pinnedBottomRowData={pinnedBottomRowData}
        rowHeight={36}
      />
    </div>
  );
};
